"use client";

import SavedLinkCard from "@/components/SavedLinkCard";
import type { KundaliLang } from "./KundaliFormCard.i18n";

/**
 * Durable return path for the inline kundali result: every generated kundali
 * is persisted under its reading id, and /kundali/<id> re-renders the same
 * KundaliResult tree. Additive below the inline result (rule 46 — the value
 * moment stays put).
 */
export default function KundaliSavedLink({
  readingId,
  language,
}: {
  readingId: string;
  language: KundaliLang;
}) {
  const hi = language === "hi";
  return (
    <div className="mt-6">
      <SavedLinkCard
        path={`/kundali/${readingId}/${hi ? "?lang=hi" : ""}`}
        heading={hi ? "आपकी कुंडली सेव हो गई है" : "Your kundali is saved"}
        body={
          hi
            ? "इस लिंक से कभी भी दोबारा खोलें — जन्म विवरण दोबारा भरने की ज़रूरत नहीं।"
            : "Return to it anytime with this link — no need to re-enter your birth details."
        }
        shareLabel={hi ? "लिंक साझा करें" : "Share link"}
        copiedLabel={hi ? "Link copy ho gaya" : "Link copied"}
        analyticsEvent="kundali_saved_link_clicked"
        analyticsProps={{ reading_id: readingId, language }}
      />
    </div>
  );
}
